"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuAccordionItem = exports.MenuAccordionButton = exports.MenuAccordion = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./pixelated.menu-accordion.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========== MENU ========== */
class MenuAccordion extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "componentDidMount", () => {
      const menu = document.getElementById('accordion-menu');
      const menuBtn = document.getElementById('panel-menu-button');
      document.addEventListener('click', event => {
        const isClicked = menu.contains(event.target) || menuBtn.contains(event.target);
        if (!isClicked) {
          if (this.state.left === 0) this.moveMenu();
        }
      }, true);
    });
    this.state = {
      menuItems: [],
      left: -350
    };
    this.moveMenu = this.moveMenu.bind(this);
  }
  generateMenuItems() {
    const myItems = [];
    for (const itemKey in this.props.menuItems) {
      myItems.push( /*#__PURE__*/_react.default.createElement(MenuAccordionItem, {
        key: itemKey,
        name: itemKey,
        href: this.props.menuItems[itemKey]
      }));
    }
    // this.setState({ menuItems: myItems })
    return myItems;
  }
  moveMenu() {
    if (this.state.left === 0) {
      this.setState({
        left: -350
      });
    } else {
      this.setState({
        left: 0
      });
    }
  }
  componentWillUnmount() {
    window.removeEventListener('click', this.handleResize);
  }
  render() {
    const styles = {
      left: '0px'
    };
    styles.transition = 'transform 0.5s ease-out 0.0s';
    styles.transform = 'translateX(' + this.state.left + 'px)';
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "accordion-menu-wrapper",
      style: styles
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "accordion-menu",
      id: "accordion-menu"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "grid12 clearfix"
    }, this.generateMenuItems())));
  }
}

/* ========== MENU ITEM ========== */
exports.MenuAccordion = MenuAccordion;
_defineProperty(MenuAccordion, "propTypes", {
  menuItems: _propTypes.default.object.isRequired
});
class MenuAccordionItem extends _react.Component {
  render() {
    return /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
      href: this.props.href
    }, this.props.name));
  }
}

/* ========== MENU BUTTON ========== */
exports.MenuAccordionItem = MenuAccordionItem;
_defineProperty(MenuAccordionItem, "propTypes", {
  name: _propTypes.default.string.isRequired,
  href: _propTypes.default.string.isRequired
});
class MenuAccordionButton extends _react.Component {
  slideMobilePanel() {
    window.myMenu.moveMenu();
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "panel-menu-button pull-left",
      id: "panel-menu-button",
      onClick: this.slideMobilePanel
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: "/images/mobile-menu2.png",
      alt: "Mobile Menu"
    }));
  }
}
exports.MenuAccordionButton = MenuAccordionButton;